import { array, boolean, literal, nullable, number, partial, record, union } from 'io-ts/Decoder';

import { HexColor } from '../../../ui/HexColor';

import { DesignTransactionsType } from './report/DesignTransactionsType';
import {
	WoHParameterType,
	WoHBoMType,
	WoHFormulaType,
	FPCType,
	JobType,
	WoHMaterialTemplateType,
	WoHMaterialType,
	WoHRecipeCopyType,
	WoHRecipeType,
	TransactionType,
	WoHUsageType,
	UserAdminType,
	UserEstimatorsType,
	OrganizationAdminType,
	PrincipalAdminType,
	ProjectType,
	ResourceAdminType,
} from './search-data-table';

export const Type = partial({
	// Examples of dataTables: 'userAdmin', 'userEmployee', 'fpcGlobal', 'fpcJob'
	dataTables: record(
		partial({
			pagination: partial({
				size: number,
			}),
			// Other data table settings (e.g filters, sorting)
		})
	),

	searchDataTables: partial({
		fpcGlobal: FPCType,
		fpcJob: FPCType,
		jobDashboard: JobType,
		jobRelated: JobType,
		organizationAdmin: OrganizationAdminType,
		principalAdmin: PrincipalAdminType,
		projectDashboard: ProjectType,
		resourceAdmin: ResourceAdminType,
		trxDashboard: TransactionType,
		trxRelated: TransactionType,
		userAdmin: UserAdminType,
		userEstimators: UserEstimatorsType,
		wohBoMTrx: WoHBoMType,
		wohParameter: WoHParameterType,
		wohUsage: WoHUsageType,
		wohFormula: WoHFormulaType,
		wohMaterialTemplate: WoHMaterialTemplateType,
		wohMaterial: WoHMaterialType,
		wohRecipe: WoHRecipeType,
		wohRecipeCopy: WoHRecipeCopyType,
	}),

	fpc: partial({
		linkTextLayers: boolean,
		linkMeasurementLayers: boolean,
	}),

	wholeHouse: partial({
		importLayerStyle: union(literal('centreline'), literal('bounding-box')),

		/** Take-off tool BoM preview settings — one bag so it can grow (sorting, …). */
		bomPreview: partial({
			/**
			 * How the preview arranges materials: grouped by the layer combination
			 * that produced them, or flat (null — also the default when absent).
			 */
			groupBy: nullable(literal('layer')),
		}),

		/**
		 * User-curated recent colour palette. Custom hex colours added via the
		 * advanced colour picker are appended here (most-recent first, FIFO,
		 * capped client-side at `MAX_CUSTOM_LAYER_COLORS` — the visible
		 * recents-row size on the swatch popover).
		 */
		recentColours: partial({
			custom: array(HexColor),
		}),
	}),

	report: partial({
		designTransactions: DesignTransactionsType,
	}),

	// Other UI settings (e.g. dark mode, default landing page, etc.).
});
